var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTickBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tick-black_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-.359 -.883)",
    d: "M0 0h14v14H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.359 .883)",
    clipPath: "url(#tick-black_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "tick"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 101",
    d: "M1.728 5.294l4.035 4.035-1.191 1.19L.537 6.486z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 102",
    d: "M12.847 3.243L5.11 10.98 3.84 9.71l7.736-7.738z"
  })))));
}

export default __webpack_public_path__ + "34a2023132f3c398fd0aebec818293e1.svg";
export { SvgTickBlack as ReactComponent };